import React from 'react';

export const ArrowLeft = () => (
  <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.04289 9.20698C4.43342 9.59751 5.06658 9.59751 5.45711 9.20698C5.84763 8.81646 5.84763 8.18329 5.45711 7.79277L2.66427 4.99994L5.45711 2.20711C5.84763 1.81658 5.84763 1.18342 5.45711 0.792893C5.06658 0.402369 4.43342 0.402369 4.04289 0.792893L0.542954 4.29283C0.15243 4.68336 0.15243 5.31652 0.542954 5.70704L4.04289 9.20698Z"
      fill="#8E8E8E"
    />
  </svg>
);

export const ArrowRight = () => (
  <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.95723 0.792893C1.5667 0.402369 0.933539 0.402369 0.543015 0.792893C0.152491 1.18342 0.152491 1.81658 0.543015 2.20711L3.33585 4.99994L0.543015 7.79277C0.152491 8.1833 0.152491 8.81646 0.543015 9.20698C0.93354 9.59751 1.5667 9.59751 1.95723 9.20698L5.45717 5.70705C5.84769 5.31652 5.84769 4.68336 5.45717 4.29283L1.95723 0.792893Z"
      fill="#8E8E8E"
    />
  </svg>
);

export const OrderIcon = () => (
  <svg width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.00158691 0.5C0.00158691 0.223858 0.225445 0 0.501587 0H7.50159C7.77773 0 8.00159 0.223858 8.00159 0.5C8.00159 0.776142 7.77773 1 7.50159 1H0.501587C0.225445 1 0.00158691 0.776142 0.00158691 0.5Z"
      fill="#646464"
    />
    <path
      d="M1.00159 3.5C1.00159 3.22386 1.22544 3 1.50159 3H6.50159C6.77773 3 7.00159 3.22386 7.00159 3.5C7.00159 3.77614 6.77773 4 6.50159 4H1.50159C1.22544 4 1.00159 3.77614 1.00159 3.5Z"
      fill="#646464"
    />
    <path
      d="M2.50159 6C2.22544 6 2.00159 6.22386 2.00159 6.5C2.00159 6.77614 2.22544 7 2.50159 7H5.50159C5.77773 7 6.00159 6.77614 6.00159 6.5C6.00159 6.22386 5.77773 6 5.50159 6H2.50159Z"
      fill="#646464"
    />
  </svg>
);

export const OrderArrowIcon = () => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 0L6.59808 3H1.40192L4 0Z" fill="#646464" />
    <path d="M4 8L1.40192 5L6.59808 5L4 8Z" fill="#646464" />
  </svg>
);

export const ActionsIcon = () => (
  <svg width="4" height="14" viewBox="0 0 4 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.5 1.75C3.5 2.57843 2.82843 3.25 2 3.25C1.17157 3.25 0.5 2.57843 0.5 1.75C0.5 0.921573 1.17157 0.25 2 0.25C2.82843 0.25 3.5 0.921573 3.5 1.75Z"
      fill="#8E8E8E"
    />
    <path
      d="M3.5 7C3.5 7.82843 2.82843 8.5 2 8.5C1.17157 8.5 0.5 7.82843 0.5 7C0.5 6.17157 1.17157 5.5 2 5.5C2.82843 5.5 3.5 6.17157 3.5 7Z"
      fill="#8E8E8E"
    />
    <path
      d="M2 13.75C2.82843 13.75 3.5 13.0784 3.5 12.25C3.5 11.4216 2.82843 10.75 2 10.75C1.17157 10.75 0.5 11.4216 0.5 12.25C0.5 13.0784 1.17157 13.75 2 13.75Z"
      fill="#8E8E8E"
    />
  </svg>
);

export const ActionIconWhite = () => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 1.5C0 1.22386 0.223858 1 0.5 1H7.5C7.77614 1 8 1.22386 8 1.5C8 1.77614 7.77614 2 7.5 2H0.5C0.223858 2 0 1.77614 0 1.5Z"
      fill="white"
    />
    <path
      d="M1 4.5C1 4.22386 1.22386 4 1.5 4H6.5C6.77614 4 7 4.22386 7 4.5C7 4.77614 6.77614 5 6.5 5H1.5C1.22386 5 1 4.77614 1 4.5Z"
      fill="white"
    />
    <path
      d="M2.5 7C2.22386 7 2 7.22386 2 7.5C2 7.77614 2.22386 8 2.5 8H5.5C5.77614 8 6 7.77614 6 7.5C6 7.22386 5.77614 7 5.5 7H2.5Z"
      fill="white"
    />
  </svg>
);

export const KebabDisabled = () => (
  <svg width="4" height="14" viewBox="0 0 4 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.5 1.75C3.5 2.57843 2.82843 3.25 2 3.25C1.17157 3.25 0.5 2.57843 0.5 1.75C0.5 0.921573 1.17157 0.25 2 0.25C2.82843 0.25 3.5 0.921573 3.5 1.75Z"
      fill="#E5E5E5"
    />
    <path
      d="M3.5 7C3.5 7.82843 2.82843 8.5 2 8.5C1.17157 8.5 0.5 7.82843 0.5 7C0.5 6.17157 1.17157 5.5 2 5.5C2.82843 5.5 3.5 6.17157 3.5 7Z"
      fill="#E5E5E5"
    />
    <path
      d="M2 13.75C2.82843 13.75 3.5 13.0784 3.5 12.25C3.5 11.4216 2.82843 10.75 2 10.75C1.17157 10.75 0.5 11.4216 0.5 12.25C0.5 13.0784 1.17157 13.75 2 13.75Z"
      fill="#E5E5E5"
    />
  </svg>
);

export const Generate = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 260.000000 260.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g transform="translate(0.000000,260.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
      <path
        d="M1906 2584 c-139 -34 -169 -56 -473 -358 -257 -254 -283 -283 -283
        -313 0 -44 30 -73 74 -73 32 0 57 22 303 266 292 289 323 313 451 335 264 47
        509 -201 463 -467 -24 -134 -42 -158 -395 -509 -337 -337 -364 -358 -477 -384
        -123 -29 -253 6 -358 93 -54 45 -100 49 -130 10 -34 -43 -27 -72 28 -124 161
        -151 414 -183 631 -78 57 27 106 72 398 362 183 182 349 355 369 385 147 221
        114 519 -79 710 -135 134 -337 190 -522 145z"
      />
      <path
        d="M980 1664 c-141 -37 -160 -52 -518 -408 -183 -182 -349 -355 -369
        -385 -145 -218 -115 -515 72 -702 175 -176 426 -217 654 -107 57 28 104 70
        349 312 256 254 282 283 282 313 0 43 -30 73 -73 73 -30 0 -59 -25 -301 -266
        -292 -290 -322 -312 -454 -335 -264 -47 -509 201 -463 467 23 132 43 158 395
        509 343 343 364 360 487 386 114 25 250 -12 347 -94 55 -46 100 -50 131 -11
        34 43 27 72 -28 124 -57 53 -151 103 -236 125 -74 19 -202 18 -275 -1z"
      />
    </g>
  </svg>
);

export const Copy = () => (
  <svg width="20" height="20" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M26.6667 33.3335H13.3333C12.0073 33.3335 10.7355 32.8067 9.7978 31.869C8.86012 30.9314 8.33333 29.6596 8.33333 28.3335V11.6668C8.33333 11.2248 8.15774 10.8009 7.84518 10.4883C7.53262 10.1758 7.10869 10.0002 6.66667 10.0002C6.22464 10.0002 5.80072 10.1758 5.48816 10.4883C5.17559 10.8009 5 11.2248 5 11.6668V28.3335C5 30.5436 5.87797 32.6632 7.44078 34.2261C9.00358 35.7889 11.1232 36.6668 13.3333 36.6668H26.6667C27.1087 36.6668 27.5326 36.4912 27.8452 36.1787C28.1577 35.8661 28.3333 35.4422 28.3333 35.0002C28.3333 34.5581 28.1577 34.1342 27.8452 33.8217C27.5326 33.5091 27.1087 33.3335 26.6667 33.3335ZM16.6667 21.6668C16.6667 22.1089 16.8423 22.5328 17.1548 22.8453C17.4674 23.1579 17.8913 23.3335 18.3333 23.3335H26.6667C27.1087 23.3335 27.5326 23.1579 27.8452 22.8453C28.1577 22.5328 28.3333 22.1089 28.3333 21.6668C28.3333 21.2248 28.1577 20.8009 27.8452 20.4883C27.5326 20.1758 27.1087 20.0002 26.6667 20.0002H18.3333C17.8913 20.0002 17.4674 20.1758 17.1548 20.4883C16.8423 20.8009 16.6667 21.2248 16.6667 21.6668ZM35 14.9002C34.9826 14.7471 34.9491 14.5962 34.9 14.4502V14.3002C34.8199 14.1288 34.713 13.9713 34.5833 13.8335L24.5833 3.8335C24.4456 3.70386 24.288 3.59696 24.1167 3.51683C24.0669 3.50976 24.0164 3.50976 23.9667 3.51683C23.7974 3.41973 23.6104 3.3574 23.4167 3.3335H16.6667C15.3406 3.3335 14.0688 3.86028 13.1311 4.79796C12.1935 5.73564 11.6667 7.00741 11.6667 8.3335V25.0002C11.6667 26.3262 12.1935 27.598 13.1311 28.5357C14.0688 29.4734 15.3406 30.0002 16.6667 30.0002H30C31.3261 30.0002 32.5979 29.4734 33.5355 28.5357C34.4732 27.598 35 26.3262 35 25.0002V15.0002C35 15.0002 35 15.0002 35 14.9002ZM25 9.01683L29.3167 13.3335H26.6667C26.2246 13.3335 25.8007 13.1579 25.4882 12.8453C25.1756 12.5328 25 12.1089 25 11.6668V9.01683ZM31.6667 25.0002C31.6667 25.4422 31.4911 25.8661 31.1785 26.1787C30.866 26.4912 30.442 26.6668 30 26.6668H16.6667C16.2246 26.6668 15.8007 26.4912 15.4882 26.1787C15.1756 25.8661 15 25.4422 15 25.0002V8.3335C15 7.89147 15.1756 7.46755 15.4882 7.15499C15.8007 6.84242 16.2246 6.66683 16.6667 6.66683H21.6667V11.6668C21.6712 12.2354 21.7726 12.799 21.9667 13.3335H18.3333C17.8913 13.3335 17.4674 13.5091 17.1548 13.8217C16.8423 14.1342 16.6667 14.5581 16.6667 15.0002C16.6667 15.4422 16.8423 15.8661 17.1548 16.1787C17.4674 16.4912 17.8913 16.6668 18.3333 16.6668H31.6667V25.0002Z"
      fill="#101010"
    />
  </svg>
);
